
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Antibes dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Antibes certifiée Google Partner, accompagne les entreprises antiboises pour accroître leur visibilité sur internet et développer leur clientèle.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Antibes dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Antibes certifiée Google Partner, accompagne les entreprises antiboises pour accroître leur visibilité sur internet et développer leur clientèle.",
        },
      ],
    };
  },
};
